window.addEventListener("DOMContentLoaded", () => {
  setTimeout(
    () => {
      function replaceImagesWithVideos() {
        const replacementImages = document.querySelectorAll("img[data-video]");
        replacementImages.forEach((image) => {
          if (window.getComputedStyle(image).display !== "none") {
            const d = document.createElement("div");
            d.innerHTML = image.getAttribute("data-video");
            const video = d.querySelector("video");
            image.parentElement.replaceChild(video, image);
          }
        });
      }
      window.addEventListener("resize", replaceImagesWithVideos);
      replaceImagesWithVideos();
    },
    /^((?!chrome|android).)*safari/i.test(navigator.userAgent) ? 2500 : 0
  );
});
